export default "__VITE_ASSET__c942e6f7__"